import Component from '@glimmer/component';
import { type EventInfoComponentArgs } from 'donor-elf-web/components/event/index';
import formatAmount from 'donor-elf-web/helpers/format-amount';

export default class EventInfoBelowRegularAmountComponent extends Component<EventInfoComponentArgs> {
  get decreaseAmount() {
    return (
      this.args.eventModel.custom.regular_amount -
      this.args.eventModel.custom.donation_amount
    );
  }

  <template>
    <div>
      They gave
      {{formatAmount this.decreaseAmount removeNoCents=true}}
      below their regular amount. Their pledge is for
      {{formatAmount @eventModel.custom.regular_amount removeNoCents=true}} but this
      time they gave
      {{formatAmount @eventModel.custom.donation_amount removeNoCents=true}}.
    </div>
  </template>
}
